// Feature flags de build. Mesmo modelo do VITE_BRAND (src/brand/index.ts):
// resolvidas em BUILD-TIME pelo Vite, entao trocar o valor exige rebuild do
// bundle (`bash scripts/dev-up.sh rebuild web`) ou restart do `pnpm dev`.
// Nao existe flag em runtime aqui - o nginx serve estatico.

/**
 * Interpreta env var booleana. Ausente ou string vazia cai no fallback;
 * 'false', '0', 'off', 'no' desligam; qualquer outro valor liga.
 */
function envFlag(raw: string | undefined, fallback: boolean): boolean {
  const v = raw?.trim().toLowerCase();
  if (v === undefined || v === '') return fallback;
  return !['false', '0', 'off', 'no'].includes(v);
}

/**
 * VITE_TERMINAL_RECOLHA_ENABLED=false esconde os atalhos para o fluxo de
 * Recolha (/rede/recolha) dentro do terminal web:
 *  - botao "Anexar NF na Recolha" no comprovante (ConclusionStep)
 *  - botao "recolha" da coluna XML em "Ultimas vendas" (LastSalesPanel)
 *
 * Default true: build sem a env var fica identico ao comportamento de hoje.
 * Nao afeta o modulo Recolha em si (/rede/recolha e /recolha continuam
 * acessiveis por rota e sidebar conforme RBAC).
 */
export const TERMINAL_RECOLHA_ENABLED = envFlag(
  import.meta.env.VITE_TERMINAL_RECOLHA_ENABLED as string | undefined,
  true,
);

/**
 * VITE_RECOLHA_MENU_ENABLED controla os itens de Recolha na sidebar:
 *  - perfil frotista: "Notas Fiscais" (/recolha)
 *  - perfil posto: "Recolha de NFe" (/rede/recolha)
 *
 * Default false: o modulo fica fora do menu do portal. As rotas continuam
 * registradas e protegidas por RBAC, entao quem tem o link direto ainda
 * acessa (ocultar menu nao e controle de acesso; isso e backend).
 * Para reexibir sem mexer em codigo: VITE_RECOLHA_MENU_ENABLED=true + rebuild.
 */
export const RECOLHA_MENU_ENABLED = envFlag(
  import.meta.env.VITE_RECOLHA_MENU_ENABLED as string | undefined,
  false,
);
